import React, {useState, useEffect} from "react";
import Container from "@material-ui/core/Container";
import Title from "../dashboard/Title";
import Button from "@material-ui/core/Button";
import SelectInput from "../form/input/SelectInput";
import UserService from "../../services/user.service";
import {logOut} from "../../helpers/logout";
import {NotificationManager} from 'react-notifications';
import Paper from "@material-ui/core/Paper";
import TextInput from "../form/input/TextInput";
import Popup from "../presentation/Popup";
import ActionButton from "../form/input/ActionButton";
import Tooltip from "@material-ui/core/Tooltip";
import EditIcon from "@material-ui/icons/Edit";
import AddIcon from "@material-ui/icons/Add";
import DeleteIcon from "@material-ui/icons/Delete";
import ConfirmDialog from "../presentation/ConfirmDialog";
import useTable from "../presentation/useTable";
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import {useDashboardStyles, BRAND} from "./dashboardStyles";
import {makeStyles} from "@material-ui/core/styles";

const useLocalStyles = makeStyles((theme) => ({
    statusBadgeFuneral: {
        display: "inline-flex",
        alignItems: "center",
        padding: "3px 9px",
        background: "rgba(44, 71, 103, 0.10)",
        color: BRAND.deep,
        borderRadius: 999,
        fontSize: "0.7rem",
        fontWeight: 700,
        letterSpacing: 0.6,
        textTransform: "uppercase",
        border: `1px solid rgba(44, 71, 103, 0.20)`,
    },
    statusBadgeGeneral: {
        display: "inline-flex",
        alignItems: "center",
        padding: "3px 9px",
        background: BRAND.goldBg,
        color: BRAND.deep,
        borderRadius: 999,
        fontSize: "0.7rem",
        fontWeight: 700,
        letterSpacing: 0.6,
        textTransform: "uppercase",
        border: `1px solid ${BRAND.goldSoft}`,
    },
}));

export default function TasksDashboard(props) {
    const classes = useDashboardStyles();
    const localClasses = useLocalStyles();

    const [tasks, setTasks] = useState([]);
    const [filterFn] = useState({
        fn: items => {
            return items;
        }
    });
    const [limit] = useState(100);

    const [values, setValues] = useState({
        _id: null,
        name: '',
        status: 1
    });

    const headCells = [
        {id: 'name', label: 'Názov'},
        {id: 'status', label: 'Stav'},
        {id: 'actions', label: 'Akcie', disableSorting: true, align: 'right'}
    ]

    const {
        TblContainer,
        TblHead,
        TblPagination,
        recordsAfterPagingAndSorting
    } = useTable(tasks, headCells, filterFn);

    const [show, setShow] = useState(false);
    const [confirmDialog, setConfirmDialog] = useState({isOpen: false, title: '', subTitle: ''})

    const handleChange = (event) => {
        const {name, value} = event.target;
        setValues({...values, [name]: value});
    }

    useEffect(() => {
        UserService.getTaskTemplates().then(
            (response) => {
                setTasks(response.data);
            },
            (e) => {
                if (e.response.status === 401) {
                    logOut(props);
                }
            }
        );
    }, [limit, props]);

    const resetToDefault = () => {
        setValues({
            _id: null,
            name: '',
            status: 0,
        });
        setShow(false);
    }

    const errNotification = (e) => {
        if (e.response.status === 401) {
            logOut(props);
            NotificationManager.error('Musíte sa nanovo prihlásiť.', 'Chyba', 5000);
        } else {
            NotificationManager.error('Došlo k neočakávanej chybe. Skúste neskôr alebo kontaktujte podporu.', 'Chyba', 5000);
        }
    }

    const handleCreate = (e) => {
        e.preventDefault();

        if (validate()) {
            let data = {
                _id: values._id,
                status: values.status,
                name: values.name
            };

            if (values._id) {
                UserService.updateTaskTemplate(data).then(
                    () => {
                        UserService.getTaskTemplates().then(
                            (response) => {
                                setTasks(response.data);
                                NotificationManager.success('Úloha upravená!', 'Upravené', 5000);
                            },
                            (e) => {
                                if (e.response.status === 401) {
                                    logOut(props);
                                }
                            }
                        );
                        resetToDefault();
                    },
                    (e) => {
                        errNotification(e);
                    }
                );
            } else {
                data.created = new Date();
                UserService.addTaskTemplate(data).then(
                    () => {
                        UserService.getTaskTemplates().then(
                            (response) => {
                                setTasks(response.data);
                                NotificationManager.success('Úloha vytvorená!', 'Vytvorené', 5000);
                            },
                            (e) => {
                                if (e.response.status === 401) {
                                    logOut(props);
                                }
                            }
                        );
                        resetToDefault();
                    },
                    (e) => {
                        errNotification(e);
                    }
                );
            }
        } else {
            NotificationManager.error('Skontrolujte vyplnený formulár!', 'Chyba', 5000);
        }
    };

    const [errors, setErrors] = useState({});

    const validate = () => {
        let temp = {};
        temp.name = values.name !== '' ? "" : "Vyplne názov."
        if (values.type === 1 && values.options.length === 0) {
            temp.type = 'Musíte mať aspon jendu možnosť!'
        }
        if (values.type === 4 && values.options.length === 0) {
            temp.type = 'Musíte mať aspon jendu možnosť!'
        }
        if (!values.status) {
            temp.status = "Musíte vybrať jednú z možností"
        }
        setErrors({...temp})
        // eslint-disable-next-line eqeqeq
        return Object.values(temp).every(x => x == "")
    }

    const handleDelete = (id) => {
        setConfirmDialog({
            ...confirmDialog,
            isOpen: false
        })
        UserService.deleteTaskTemplate(id).then(
            () => {
                NotificationManager.success('Úloha vymazaná!', 'Vymazané', 5000);
                UserService.getTaskTemplates().then(
                    (response) => {
                        setTasks(response.data);
                    },
                    (e) => {
                        if (e.response.status === 401) {
                            logOut(props);
                            NotificationManager.warning('Potrebné sa znova prihlásiť!', 'Upozornenie', 5000);
                        }
                    }
                );
            },
            (e) => {
                if (e.response.status === 401) {
                    logOut(props);
                    NotificationManager.warning('Potrebné sa znova prihlásiť!', 'Upozornenie', 5000);
                }
                NotificationManager.error('Úlohu sa nepodarilo odstrániť!', 'Chyba', 5000);
            }
        );
    }

    const handleEdit = (vals) => () => {
        setValues(vals);
        setShow(true);
    }

    const getStatus = (val) => {
        switch (val) {
            case 2:
                return "Pre pohreb";
            default:
                return "Všeobecná";
        }
    }

    return (
        <Container maxWidth="lg" className={classes.pageContainer}>
            <Paper className={classes.paper} elevation={0}>
                <div className={classes.sectionHeader}>
                    <div>
                        <Title>Zoznam šablón pre úlohy</Title>
                    </div>
                    <div className={classes.sectionToolbar}>
                        <Button
                            startIcon={<AddIcon/>}
                            className={classes.primaryAction}
                            onClick={() => setShow(true)}
                        >
                            Pridať šablónu pre úlohy
                        </Button>
                    </div>
                </div>

                {tasks.length === 0 ? (
                    <div className={classes.emptyState}>
                        Zatiaľ nemáte pridané žiadne šablóny pre úlohy.
                    </div>
                ) : (
                    <>
                        <TblContainer>
                            <TblHead/>
                            <TableBody>
                                {recordsAfterPagingAndSorting().map((item, index) => (
                                    <TableRow key={index}>
                                        <TableCell>{item.name}</TableCell>
                                        <TableCell>
                                            <span className={item.status === 2 ? localClasses.statusBadgeFuneral : localClasses.statusBadgeGeneral}>
                                                {getStatus(item.status)}
                                            </span>
                                        </TableCell>
                                        <TableCell align="right">
                                            <ActionButton color="primary">
                                                <Tooltip title="Upraviť šablónu">
                                                    <EditIcon
                                                        onClick={handleEdit(item)}
                                                        fontSize="small"
                                                    />
                                                </Tooltip>
                                            </ActionButton>
                                            <ActionButton color="secondary">
                                                <Tooltip title="Vymazať šablónu">
                                                    <DeleteIcon
                                                        fontSize="small"
                                                        onClick={() => {
                                                            setConfirmDialog({
                                                                isOpen: true,
                                                                title: 'Naozaj chcete vymazať túto šablónu?',
                                                                subTitle: "Túto operáciu nevieš vrátiť.",
                                                                onConfirm: () => {
                                                                    handleDelete(item._id)
                                                                }
                                                            })
                                                        }}
                                                    />
                                                </Tooltip>
                                            </ActionButton>
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </TblContainer>
                        <TblPagination/>
                    </>
                )}

                <Popup
                    title={values._id ? 'Úprava šablóny úlohy' : 'Pridanie šablóny úlohy'}
                    openPopup={show}
                    setOpenPopup={setShow}
                    additionalWork={resetToDefault}
                    maxW="sm"
                    actions={
                        <Button
                            variant="contained"
                            type="submit"
                            form="task-template-form"
                            className={classes.primaryAction}
                        >
                            {values._id ? "Upraviť šablónu" : "Pridať šablónu"}
                        </Button>
                    }
                >
                    <form id="task-template-form" autoComplete='off' onSubmit={handleCreate}>
                        <div className={classes.formField}>
                            <TextInput
                                label="Názov"
                                error={errors.name}
                                name={'name'}
                                value={values.name}
                                onChange={handleChange}
                                fullWidth
                            />
                        </div>
                        <div className={classes.formField}>
                            <SelectInput
                                label="Typ"
                                name={'status'}
                                error={errors.status}
                                value={values.status}
                                options={[
                                    {value: 1, title: 'Všeobecná'},
                                    {value: 2, title: 'Pre pohreby'},
                                ]}
                                onChange={handleChange}
                            />
                        </div>
                    </form>
                </Popup>
            </Paper>
            <ConfirmDialog
                confirmDialog={confirmDialog}
                setConfirmDialog={setConfirmDialog}
                icon={<DeleteIcon/>}
            />
        </Container>
    );
}
